var map = {
	"./add-payment-icon.svg": "b304",
	"./arrow-down-icon.png": "0ed8",
	"./arrow-left-icon.png": "c21d",
	"./arrow-rigth-icon.png": "959c",
	"./assessment-icon.svg": "9913",
	"./basic-plan-icon.svg": "4bfe",
	"./checked-traning-icon.svg": "5b6a",
	"./credential-icon.png": "3515",
	"./dashboard-icon.svg": "80e1",
	"./documentation-icon.svg": "ee28",
	"./download-assessment-icon.svg": "2cae",
	"./download-icon.svg": "a1d8",
	"./free-trial-icon.svg": "4995",
	"./icon_download_apk.svg": "18db",
	"./location-admin-icon.svg": "b392",
	"./location-delegate-icon.svg": "5fc1",
	"./location-icon.svg": "3974",
	"./logout-icon.svg": "edff",
	"./mastercard-icon.png": "7904",
	"./medium-plan-icon.svg": "1fa3",
	"./mm-icon.svg": "4cb6",
	"./not-checked-traning-icon.svg": "f84a",
	"./pro-plan-icon.svg": "87a1",
	"./profile-icon.svg": "4a36",
	"./review-icon.png": "3ad5",
	"./sesion-traning-icon.svg": "4cc6",
	"./settings-icon.svg": "36e8",
	"./sponsors-icon.svg": "5a0f",
	"./training-icon.png": "d569",
	"./training-icon.svg": "5710",
	"./users-icon.svg": "3998",
	"./visa-icon.png": "74af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";